export const moveArrayElement = <T>(anyArray: T[], index: number, targetIndex: number): T[] => {
  const newArray = [...anyArray];
  const removedElements = newArray.splice(index, 1);
  if (removedElements.length) {
    newArray.splice(targetIndex, 0, removedElements[0]);
  }
  return newArray;
};
